export default [
  ['', ''],
  ['目标链网络不稳定', 'The target chain network is unstable'],
  ['已注册', 'Signup at'],
  ['提现', 'Withdraw'],
  ['· 绑定后, 区块确定需要一定的时间', '· After signing, you need to wait for block confirmation'],
  ['· 绑定后不能再修改', '· Cannot be modified after binding'],
  ['填写邀请地址', 'Fill in the invitation address'],
  ['邀请好友获得得佣金奖励', 'invite friends Get commission rewards'],
  ['全部时间', 'All time'],
  ['过去7天内', 'Within seven days'],
  ['过去30天内', 'Within 30 days'],
  ['过去一年内', 'Within a year'],
  ['已注册', 'Registered'],
  ['总计交易佣金奖励', 'Total Commission'],
  ['本周获得奖励', 'Weekly Rewards'],
  ['本月获得奖励', 'Monthly Rewards'],
  ['注册时长', 'Registration Time'],
  ['本月用户邀请排名', 'Monthly List'],
  ['本周用户邀请排名', 'Weekly List'],
  ['排行榜', 'Leader Board'],
  ['时间', 'Time'],
  ['交易佣金奖励', 'Trading Commissions'],
  ['被邀请人交易额', 'Number Of Invitees'],
  ['我的交易佣金奖励明细', 'Transaction Commission Details'],
  ['总计获得佣金奖励', 'Total Commission'],
  ['邀请未提佣金', 'Commission Pending'],
  ['成功邀请人数', 'Valid Invitation'],
  ['推荐用户总数', 'Total Referral Users'],
  ['我的推荐历史', 'My Referral History'],
  ['当您的朋友，使用了Hieswap进行跨链，您能获得对应的邀请奖励，不上限奖励。', 'Join HieSwap, get your referral link, and register customers through this link to get benefits.'],
  ['复制你的推荐链接并发送给朋友。', 'Copy your referral link and send it to a friend.'],
  ['加入HieSwap，获取您的推荐链接，通过此链接注册客户讲获得收益。', 'When your friends use it, you will get unlimited rewards.'],
  ['3、新人奖金', '3. newcomer bonus'],
  ['2、邀请朋友', '2. Invite friends'],
  ['1、获取链接', '1. get link'],
  ['活动指引', 'Activity Guidelines'],
  ['邀请好友', 'Invite Friends'],
  ['邀请链接', 'Referral Link'],
  ['邀请码', 'Referral Code'],
  ['邀请好友得奖励', 'Invite Friends and Earn Up to'],
  ['佣金USDT', 'CommissionUSDT'],
  ['好友邀请', 'Invite'],
  ['已连接', 'Connected with'],
  ['在浏览器上查看', 'View on Explorer'],
  ['复制地址', 'Copy Address'],
  ['复制成功', 'Copied'],
  ['切换', 'Change'],
  ['账户', 'Account'],
  ['返回', 'Back'],
  ['连接钱包', 'Connect to a wallet'],
  ['当前钱包', 'Current wallet'],
  ['单笔数量USDT', 'Per Tx USDT'],
  ['使用', 'Use '],
  ['自定义', 'Custom'],
  ['地址', ' address'],
  ['输入以T开头的TRON网络接收地址', 'Enter the TRON receiving address starting with T'],
  ['输入以0x开头的接收地址', 'Enter the receiving address starting with 0x'],
  ['接收地址无效', 'Invalid recipient address'],
  ['搜索公链', 'Search chain'],
  ['接收地址', 'Recipient Address'],
  ['查看', 'Check'],
  ['接收', 'Take over'],
  ['请填写您本人可收款的钱包地址。请勿使用交易所统一充值地址或托管钱包，以免影响入账。', 'Use a wallet address you control for receiving. Avoid generic exchange deposit or custodial addresses so funds credit correctly.'],
  ['温馨提醒：请勿使用交易所、合约或托管钱包地址作为接收地址。', 'Friendly reminder: do not use exchange, contract, or custodial wallet addresses for receiving.'],
  ['建议使用你本人可控的钱包地址，避免跨链资产无法入账。', 'Please use a wallet address fully controlled by you to avoid failed crediting.'],
  ['自定义地址确认', 'Custom Address Confirmation'],
  ['请再次核对接收地址，自定义地址发起后无法回滚。', 'Please verify the receiving address again. A transfer sent to a custom address cannot be rolled back.'],
  ['请勿使用交易所、合约、托管钱包地址，以免跨链资产无法入账。', 'Do not use exchange, contract, or custodial wallet addresses, or your bridged assets may fail to be credited.'],
  ['我已核对接收地址，字符与网络均正确。', 'I have verified the receiving address, and both characters and network are correct.'],
  ['我已知晓发起后不可回滚，并确认地址可自主控制。', 'I understand it cannot be rolled back after submission and confirm the address is fully self-controlled.'],
  ['返回检查', 'Back to check'],
  ['我已确认，继续', 'I have confirmed, continue'],
  ['发送至', 'Send To'],
  ['您可以切换至其他链通道', ' '],
  ['目标链，当前不满足您的本次交易', 'The target chain, the current liquidity does not meet your transaction'],
  ['流动性提示', 'liquidity reminder'],
  ['使用受限', 'limited use'],
  ['非常抱歉，我们无法向受限制的国家/地区的用户提供服务（包括使用受限国家IP的用户）', "We're sorry, but we're unable to send to restricted countries. Users provide services (including users using restricted country IP)"],
  ['知道了', 'OK'],
  ['授权中…', 'Approving…'],
  ['在钱包确认中', 'Confirm in your wallet'],
  ['授权USDT', 'Approve USDT'],
  ['选择公链', 'Select Chain'],
  ['立即兑换', 'Swap now'],
  ['取消', 'Cancel'],
  ['确定', 'Confirm'],
  ['确认', 'Confirm'],
  ['白天模式', 'Light Mode'],
  ['夜间模式', 'Dark Mode'],
  ['中文','English'],
  ['English','简体中文'],
  ['兑换','Swap'],
  ['跨链桥','Bridge'],
  ['从','From'],
  ['到','To'],
  ['余额','Balance'],
  ['最大','MAX'],
  ['接收地址','Recipient Address'],
  ['请输入地址','Please enter an address'],
  ['请输入数量','Please enter the quantity'],
  ['输入金额','Enter an amount'],
  ['余额不足', 'Insufficient balance'],
  ['费用与限额','Fees & limits'],
  ['跨链费·GAS·时间与单笔','Bridge fee, GAS, ETA & per-tx limits'],
  ['GAS·时间与单笔','GAS, ETA & per-tx limits'],
  ['连接后将使用默认地址收款', 'After connecting, funds will go to your default (connected) address.'],
  ['或开启自定义地址手动填写', 'Or enable “Custom address” below to enter one manually.'],
  ['默认地址', 'Default address'],
  ['自定义地址', 'Custom address'],
  ['跨链手续费','Bridge Fee'],
  ['目标链 GAS 费','Target GAS'],
  ['预计到账时间','ETA'],
  ['1 分钟','1 min'],
  ['首页','Home'],
  ['交易记录','Record'],
  ['记录','Records'],
  ['跨链处理中', 'Bridging…'],
  ['请耐心等待链上确认', 'Waiting for on-chain confirmation.'],
  ['加速计时剩余 {n} 秒，多数订单在 10 秒内完成。', 'Timer: {n}s — most orders finish within ~10s.'],
  ['仍在确认链上状态…', 'Still confirming on-chain…'],
  ['正在请求链上合约...', 'Requesting on-chain contract...'],
  ['链上请求稍慢，请稍候重试', 'Chain request is slow, please try again shortly.'],
  ['未检测到可用的钱包连接，请重新连接后再试', 'No wallet provider detected. Please reconnect and try again.'],
  ['链切换超时：请在钱包内切到目标网络，或刷新页面后再试', 'Network switch timed out. Select the target network in your wallet or refresh and retry.'],
  ['WalletConnect 模式下请使用「选择公链」切换网络', 'In WalletConnect mode, use “Select chain” to change networks.'],
  ['已在钱包关闭本次签名', 'You closed this step in your wallet. Try again whenever you like.'],
  ['链上请求失败，请重试', 'On-chain request failed, please retry.'],
  ['Gas 不足，请补充后重试', 'Not enough GAS, please top up and retry.'],
  ['流动性不足，请稍后重试', 'Insufficient liquidity, please retry later.'],
  ['最小兑换数量 {n} USDT', 'Minimum swap amount: {n} USDT'],
  ['最大兑换数量 {n} USDT', 'Maximum swap amount: {n} USDT'],
  ['交易完成，本次跨链耗时 {n} 秒。', 'Completed in {n} seconds.'],
  ['浏览器查看', 'View on explorer'],
  ['秒', 'seconds'],
  ['交易成功','Success'],
  ['兑换完成后在哪里查看我的资产？', 'Where can I view my assets after the swap completes?'],
  ['了解更多', 'Learn more'],
  ['等待交易成功','Waiting for confirmation'],
  ['交易进程','Transaction status'],
  ['用户地址','User Address'],
  ['类型','Type'],
  ['开始时间','Starting Time'],
  ['结束时间','End Time'],
  ['文档','Docs'],
  ['公告','Announcements'],
  ['服务条款','Terms of Service'],
  ['关于我们','About HieSwap'],
  ['语言','Language'],
  ['设置','Settings'],
  ['帮助','Help'],
  ['链接', 'Links'],
  ['官网', 'Website'],
  ['X', 'X'],
  ['电报', 'Telegram'],
  ['快捷入口', 'Quick Access'],
  ['帮助与文档', 'Docs & Support'],
  ['偏好设置', 'Preferences'],
  ['主题', 'Theme'],
  ['跨链桥','Bridge'],
  ['关闭','Close'],
  ['限时免费','Limited-time free'],
  ['最近的交易','Recent transactions'],
  ['全部清除','Clear all'],
  ['更改','Change'],
  ['跨链','Cross-chain'],
  ['暂无交易记录','No recent transactions'],
  ['加载中…','Loading…'],
  ['链上Swap','On-chain SWAP'],
  ['为兼顾安全、速度与隐私匿名，平台侧仅保留约 7 天记录；本列表只展示该范围内交易，超过天数将自行通过合约查询。','For security, speed, and privacy, we keep about 7 days of platform-side records; this list only shows that window. For older activity, verify on-chain via the smart contract or explorer.'],
  ['源链交易哈希','Source chain tx hash'],
  ['目标链TxID','Destination chain TxID'],
  ['啊哦，您似乎闯入了一个未知的区块星球', "Oops — you've wandered into an unknown chain."],
  ['无法找到所需页面，请返回首页查看更多内容', 'We could not find this page. Go back home to explore more.'],
  ['返回首页', 'Back to home'],
  ['正在估算兑换数量…', 'Estimating receive amount…'],
  ['估算中…', 'Estimating…'],
]